<!-- 盘点列表 -->
 <template>
    <div style="display: flex;flex-direction: column;  overflow: hidden;height: calc(100vh - 85px) ; background-color: #ffffff;">
        <div style=" flex-shrink: 0;">
            <el-form class="demo-form-inline" :inline="true" ref="InventoryCountSeach" :model="InventoryCountSeach" 
                size="mini" label-width="100px"> 
                <el-form-item label="盘点类型" prop="pdType"> 
                    <el-select placeholder="请选择盘点类型" v-model="InventoryCountSeach.pdType" clearable>
                        <el-option v-for="item in pdTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库名称" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="InventoryCountSeach.ckName" clearable>
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务单号" prop="billNo"> 
                    <el-input  v-model="InventoryCountSeach.billNo" placeholder="请输入任务单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="盘点名称" prop="pdName"> 
                    <el-input  v-model="InventoryCountSeach.pdName" placeholder="请输入盘点名称" clearable ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark"> 
                    <el-input  v-model="InventoryCountSeach.remark" placeholder="请输入备注" clearable ></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker v-model="createDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getCreateDate" > </el-date-picker>
                </el-form-item>
                <el-form-item label=""> 
                    <el-button size="mini" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="mini" @click="wmsGetInventoryCountList">搜索</el-button>
                    <el-button type="primary" size="mini" @click="newCountStock">新建盘点任务单</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="flex:1;overflow: hidden" >
            <vxe-table id="interWarehouseTable"  size="mini" ref="interWarehouseTable" :data="interWarehouseList" border stripe
                :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                :radio-config="{labelField: '', highlight: true}"  height="auto">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="billNo" title="任务单号" width="200" fixed="left">
                    <template v-slot="{ row }">
                        <el-link size="mini" type="primary" @click="wmsGetCountDetail(row)">{{row.billNo}}</el-link>
                    </template>
                </vxe-column>
                <vxe-column field="status" title="状态" width="130" fixed="left"></vxe-column>
                <vxe-column field="pdName" title="盘点名称" width="130" ></vxe-column>
                <vxe-column field="pdType" title="盘点类型" min-width="130" ></vxe-column>
                <vxe-column field="ckName" title="仓库" width="130" ></vxe-column>
                <vxe-column field="creator" title="单证" width="130"></vxe-column>
                <vxe-column field="createDate" title="创建日期" width="130" ></vxe-column>
                <vxe-column field="note" title="备注" min-width="130" ></vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="wmsGetInventoryCountListPager" size="mini">
        </vxe-pager>
    </div>
</template>
<script>
import { jumpInWarehouse, closeAllWarehouseWindows } from '@/config/jumpInWarehouse.js'
import basicData from '@/config/basicData.js'
export default {
    name: 'interWarehouseList',
    components:{
    },
    watch: { 
        
    },
    data() {
        return{
            createDate:[],// 创建日期列表
            hasHandledToken: false, // 是否处理过token
            InventoryCountSeach:{
                billNo:'', // 任务单号
                ckName:'', // 仓库名称
                startDate:"",
                endDate:"",
                remark:"",// 备注
                pdType:"",// 类型
                pdName:'', // 名称
            },
            ckNameList:[],  // 仓库名称列表
            interWarehouseList:[], // 库间作业列表
            ownerTransferList:[], // 货转列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 20, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
            pdTypeList:basicData.pdTypeList,
        }
    },
    created() {
        this.wmsGetInventoryCountList()
        this.getckNameList()
    },

    mounted() {
        // 监听页面卸载事件
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        newCountStock(){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'count')
        },
        // 重置表单
        resetForm(){
            this.InventoryCountSeach = {
                billNo:'', // 任务单号
                ckName:'', // 仓库名称
                startDate:"",
                endDate:"",
                remark:"",// 备注
                pdType:"",// 类型
                pdName:'', // 名称
            }
        },
        // 创建日期获取
        getCreateDate(data){
            if(data === null){
                this.InventoryCountSeach.startDate = ''
                this.InventoryCountSeach.endDate = ''
            }else{
                this.InventoryCountSeach.startDate = data[0]
                this.InventoryCountSeach.endDate = data[1]
            }
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 搜索移库
        wmsGetInventoryCountList(){
            this.pagination.currentPage = 1
            this.$api.wmsGetPdListBy(this.pagination.currentPage,this.pagination.pageSize,this.InventoryCountSeach, ).then(res =>{
                this.interWarehouseList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })

        },
        // 搜索移库分页
        wmsGetInventoryCountListPager(){
                this.$api.wmsGetPdListBy(this.pagination.currentPage,this.pagination.pageSize,this.InventoryCountSeach, ).then(res =>{
                    this.interWarehouseList = res.records
                    this.pagination.total = res.total
                    this.pagination.currentPage = res.current
                    this.pagination.pageSize = res.size
                })
        },
        // 查看详情
        wmsGetCountDetail(row){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'count')

            
        },
        handleBeforeUnload() {
            closeAllWarehouseWindows()
        },
    },
    beforeDestroy(){
        closeAllWarehouseWindows()
    },
}
</script>
<style style lang="less" scoped>
// 任务单号样式
.el-link{
    font-size: 12px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>